import Button from "components/ui/button";
import React from "react";

const LeaveForm = ({ form, onChange, onSubmit, onClose, leaveTypes,setForm}) => {
  console.log("Available leave types:", leaveTypes);
  return (
    <div className="bg-white p-6 rounded-lg shadow">
      <h2 className="text-lg font-semibold mb-4">Apply for Leave</h2>
      <form onSubmit={onSubmit} className="space-y-4">
        <div>
          <label className="block text-sm">Leave Type</label>
          <select
            name="leave_type"
            value={form.leave_type}
            onChange={(e) =>
              setForm({ ...form, leave_type: e.target.value.toLowerCase() })
            }
            className="border p-2 rounded w-full"
          >
            <option value="">Select Leave Type</option>
            {leaveTypes?.leave_types &&
              Object.keys(leaveTypes.leave_types).map((type, index) => (
                <option key={index} value={type.toLowerCase()}>
                  {type} ({leaveTypes.leave_types[type]})
                </option>
              ))}
          </select>


        </div>
        <div>
          <label className="block text-sm">Start Date</label>
          <input
            type="date"
            name="start_date"
            value={form.start_date}
            onChange={onChange}
            className="border p-2 rounded w-full"
            required
          />
        </div>
        <div>
          <label className="block text-sm">End Date</label>
          <input
            type="date"
            name="end_date"
            value={form.end_date}
            onChange={onChange}
            className="border p-2 rounded w-full"
            required
          />
        </div>
        <div>
          <label className="block text-sm">Reason</label>
          <textarea
            name="reason"
            value={form.reason}
            onChange={onChange}
            className="border p-2 rounded w-full"
            rows="3"
          />
        </div>
        <div className="flex justify-end space-x-2 mt-4">
          <Button variant="secondary" onClick={onClose} className='rounded'>Cancel</Button>
          <Button type="submit" variant="default" className='rounded'>Submit</Button>
        </div>
      </form>
    </div>
  );
};

export default LeaveForm;
